export const API_SERVER = process.env.REACT_APP_API_URL;
export const API_KEY = '98dG@Yj3xjE!7Fk9ZmA4*NpQ2RlSvB6pL0%Ubz5!C';

export const categoryMap = [
  { value: '', label: 'Select Category' },
  { label: 'Diamond', value: 'Diamond' },
  { value: 'Dhanavarsha', label: 'Dhanavarsha' },
  { label: 'Gold', value: 'Gold' },
];

export const Categories = ['Diamond', 'Dhanavarsha', 'Gold'];

export const MakerCheckerTasks = [
  { value: 'BULLION', label: 'Bullion' },
  { value: 'GOLD_SELL', label: 'Advance Book Sell' },
  { value: 'GOLD_SELL_STORE', label: 'Buy Jewellery ( Advance Book )' },
  { value: 'SAVING_PLAN_CLOSE_STORE', label: 'Buy Jewellery ( Saving Plan )' },
  {
    value: 'WITHDRAWAL_MONEY_SAVING_PLAN',
    label: 'Saving Plan ( Money Withdrawal )',
  },
  { value: 'SELL_GOLD_SAVING_PLAN', label: 'Saving Plan ( Gold Sell )' },
  { value: 'CASH_DEPOSIT', label: 'Cash Payment' },
];

export const MakerCheckerStatus = [
  { value: '', label: 'Select Status' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'FAILED', label: 'Failed' },
];

export const CheckerStatus = [
  { value: 'ACCEPT', label: 'Approve' },
  { value: 'REJECT', label: 'Reject' },
];

export const TransactionPaymentMethod = [
  { value: 'BANK_TRANSFER', label: 'Transfer via Bank' },
  { value: 'CASH', label: 'Cash Payment' },
  { value: 'PAYMENT_GATEWAY', label: 'Through Payment Gateway' },
];

export const TransactionStatus = [
  { value: '', label: 'Select Status' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'REFUNDED', label: 'Refunded' },
];

export const TransactionType = [
  { value: '', label: 'Select Transaction' },
  { value: 'CREDIT', label: 'Credit' },
  { value: 'DEBIT', label: 'Debit' },
];

export const TransactionTypeLocker = [
  { value: '', label: 'Select Transaction' },
  { value: 'CREDIT', label: 'Credit' },
  { value: 'DEBIT', label: 'Debit' },
  { value: 'HOLD', label: 'On Hold' },
  { value: 'REALIZED', label: 'Released' },
];

export const OrderStatusOptions = [
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'SEND_FOR_APPROVAL', label: 'Approval Pending' },
  { value: 'PICKUP_FROM_STORE', label: 'Pickup from Store' },
  { value: 'DRAFT', label: 'Order Created' },
  { value: 'PROCESS_TO_PAYMENT', label: 'Processing Payment' },
  { value: 'INPROGRESS', label: 'In Progress' },
];

export const OrderTypeOptions = [
  { value: 'OPEN_SAVING_PLAN', label: 'First Installment / Enrollment' },
  { value: 'CLOSE_SAVING_PLAN', label: 'Buy Jewellery ( Saving Plan )' },
  { value: 'INSTALLMENT_SAVING_PLAN', label: 'Installment' },
  // { value: 'SAVING_PLAN', label: 'Saving Plan' },
  { value: 'BUY_LOCKER', label: 'Advance Book Buy' },
  { value: 'SELL_LOCKER', label: 'Advance Book Sell' },
  { value: 'LOCKER_JEWELLERY_REDEEM', label: 'Buy Jewellery ( Advance Book )' },
  { value: 'SELL_GOLD_SAVING_PLAN', label: 'Pre-Mature Sell / Withdrawal' },
  { value: 'WITHDRAWAL_MONEY_SAVING_PLAN', label: 'Pre-Mature Withdrawal' },
];

export const OrderItemType = [
  { value: '', label: 'Select Order Type' },
  { value: 'DOCUMENT_FEES', label: 'Document Fees' },
  { value: 'GOLD_BUY', label: 'Gold Buy' },
  { value: 'GOLD_SELL', label: 'Gold Sell' },
  { value: 'SAVING_PLAN_OPEN', label: 'Saving Plan Open' },
  { value: 'SAVING_PLAN_CLOSE', label: 'Saving Plan Close' },
  { value: 'SAVING_PLAN_INSTALLMENT', label: 'Installment' },
];

export const VirtualAccountStatus = [
  { value: '', label: 'Select Status' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'SUSPENDED', label: 'Suspended' },
  { value: 'CLOSED', label: 'Closed' },
];

export const CspiStatus = [
  { value: '', label: 'Select Status' },
  { value: 'PAYMENT_RECIEVED', label: 'Payment Recieved' },
  { value: 'PAYMENT_PENDING', label: 'Payment Pending' },
];

export const CspStatus = [
  { value: '', label: 'Select Status' },
  { value: 'RUNNING', label: 'Running' },
  { value: 'READY_FOR_WITHDRAW', label: 'Ready for Withdrawal' },
  { value: 'HOLD', label: 'On Hold' },
  { value: 'SUSPENDED', label: 'Suspended' },
  { value: 'IDLE', label: 'Idle' },
  { value: 'DRAFT', label: 'Draft' },
  { value: 'INPROGRESS', label: 'In Progress' },
  { value: 'CLOSED', label: 'Closed' },
];

export const LockerLedgerStatus = [
  { value: '', label: 'Select Status' },
  { value: 'GOLD_DEBIT', label: 'Gold Debit' },
  { value: 'GOLD_CREDIT', label: 'Gold Credit' },
  { value: 'PAYMENT_RECIEVED', label: 'Payment Recieved' },
  { value: 'PAYMENT_PENDING', label: 'Payment Pending' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'FAILED', label: 'Failed' },
];

export const Status = [
  { value: '', label: 'Select Status' },
  { value: 'OPEN', label: 'Open' },
  { value: 'INPROGRESS', label: 'In Progress' },
  { value: 'RESOLVED', label: 'Resolved' },
  { value: 'CLOSED', label: 'Closed' },
];

export const UserType = [
  { value: '', label: 'Select User Type' },
  { value: 'SUPER_ADMIN', label: 'Super Admin' },
  { value: 'ADMIN', label: 'Admin' },
  { value: 'SHOWROOM', label: 'Showroom' },
  { value: 'CUSTOMER', label: 'Customer' },
];

export const CredentialsType = [
  { value: '', label: 'Select Type' },
  { value: 'PASSWORD', label: 'Password' },
  { value: 'PIN', label: 'Pin' },
];

export const Priority = [
  { value: '', label: 'Select Priority' },
  { value: 'HIGHEST', label: 'Highest' },
  { value: 'HIGH', label: 'High' },
  { value: 'NORMAL', label: 'Normal' },
  { value: 'LOW', label: 'Low' },
  { value: 'LOWEST', label: 'Lowest' },
];

export const UserCommunication = [
  { value: '', label: 'Select Communication Status' },
  { value: 'INITIALIZED', label: 'Highest' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'INPROGRESS', label: 'In Progress' },
  { value: 'FAILED', label: 'Failed' },
];

export const UserStatus = [
  { value: '', label: 'Select User Status' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'BLOCKED', label: 'Blocked' },
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'UNVERIFIED', label: 'Unverified' },
];

export const ClientStatus = [
  { value: '', label: 'Select Client Status' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'BLOCKED', label: 'Blocked' },
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'DRAFT', label: 'Draft' },
  { value: 'INPROGRESS', label: 'In Progress' },
];

export const CompanyStatus = [
  { value: '', label: 'Select Status' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'BLOCKED', label: 'Blocked' },
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'DRAFT', label: 'Draft' },
  { value: 'INPROGRESS', label: 'In Progress' },
];

export const StoreStatus = [
  { value: '', label: 'Select Status' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'BLOCKED', label: 'Blocked' },
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'DRAFT', label: 'Draft' },
  { value: 'INPROGRESS', label: 'In Progress' },
];

export const UserSessionType = [
  { value: '', label: 'Select Type' },
  { value: 'LOGIN', label: 'Login' },
  { value: 'SETPASSWORD', label: 'Set Password' },
];

export const Channel = [
  { value: '', label: 'Select Type' },
  { value: 'EMAIL', label: 'E-mail' },
  { value: 'SMS', label: 'SMS' },
];

export const CommunicationChannel = [
  { value: 'MAIL', label: 'Mail' },
  { value: 'SMS', label: 'SMS' },
  { value: 'PUSH_NOTIFICATION', label: 'Push Notification' },
];

export const OtpType = [
  { value: '', label: 'Select Type' },
  { value: 'LOGIN', label: 'Login' },
  { value: 'SIGNUP', label: 'Sign Up' },
  { value: 'VERIFY_EMAIL', label: 'Verify Email' },
  { value: 'SELL_ORDER', label: 'Sell Order' },
];

export const MetalTypes = ['GOLD24KT', 'GOLD22KT', 'SILVER'];

export const MetalTypesOptions = [
  { value: 'GOLD22KT', label: 'Gold 22 karat', type: 'type' },
  // { value: 'GOLD24KT', label: 'Gold 24 karat', type: 'type' },
  { value: 'SILVER', label: 'Silver', type: 'type' },
];

export const AddressType = [
  { value: '', label: 'Select Type' },
  { value: 'PERMANENT', label: 'Permanent' },
  { value: 'TEMPORARY', label: 'Temporary' },
];

export const SavingPlanChargeType = [
  { value: '', label: 'Select Type' },
  { value: 'ACCOUNT_OPEN', label: 'Account Open' },
  // { value: 'ACCOUNT_CLOSED', label: 'Account Closed' },
  // { value: 'PREMATURE_WITHDRAWAL', label: 'Premature Withdrawal' },
];

export const BankAccountType = [
  { value: '', label: 'Select Type' },
  { value: 'SAVING', label: 'Savings Account' },
  { value: 'CURRENT', label: 'Current Account' },
];

export const Modules = Object.freeze({
  SavingPlan: 'Saving Plan',
  OperationLocation: 'Operation Location',
  BullionDesk: 'Bullion Desk',
  BullionConfig: 'Bullion Config',
  SavingPlanVariant: 'Saving Plan Variant',
  SavingPlanStore: 'Saving Plan Store',
  Branch: 'Branch',
  Orders: 'Customer Order',
  Lockers: 'Customer Lockers',
  Client: 'Client',
  CustomerOrder: 'Customer Order',
  ClientConfig: 'Client Config',
  Company: 'Company',
  Faq: 'Faq',
  Customer: 'Customer',
  AdminUser: 'Admin User',
  PermissionGroup: 'Permission Group',
  Company_Store: 'Company Branch',
  CustomerTicket: 'Customer Ticket',
  CustomerSavingPlans: 'Customer Saving Plans',
  Kyc: 'Customer Kyc',
  MakerCheckers: 'Maker Checkers',
  CustomerBank: 'Customer Bank',
  Store: 'Store',
  ShowroomCustomerAccess: 'Showroom Customer Access',
  UserCommunication: 'User Communication',
});

export const DashboardSummary = [
  { key: 'company', label: 'Company', url: '/admin/companies' },
  { key: 'admin_user', label: 'Admin User', url: '/admin/adminusers' },
  { key: 'customer', label: 'Customer', url: '/admin/customerusers' },
  {
    key: 'customer_bank_verified',
    label: 'Customer',
    url: '/admin/customerusers',
  },
  {
    key: 'customer_aadhar_verified',
    label: 'Customer',
    url: '/admin/customerusers',
  },
  {
    key: 'customer_pan_verified',
    label: 'Customer',
    url: '/admin/customerusers',
  },
  {
    key: 'gold_locker',
    label: 'Advance Book',
    url: '/admin/lockertransactions',
  },
  {
    key: 'customer_saving_plan',
    label: 'Customer Saving Plan',
    url: '/admin/mysavingplans',
  },
  { key: 'customer_order', label: 'Customer Order', url: '/admin/orders' },
  {
    key: 'customer_ticket',
    label: 'Customer Ticket',
    url: '/admin/ticketlist',
  },
  { key: 'maker_checker', label: 'Maker Checker', url: '/admin/makercheckers' },
];
